export default "__VITE_ASSET__33614d51__"